import { Button } from "@atoms/index"

import styles from "./ButtonCell.module.scss"
import { ButtonCellProps } from "./ButtonCell.types"

function ButtonCell(props: ButtonCellProps) {
    const { children, onClick, variant = "subtle", leftIcon, isProcessing = false, isDisabled = false } = props

    // The wrapper shields the button from the table's row-level click handler, so pressing
    // the action never doubles as a row navigation.
    const stopRowClick = (event: React.MouseEvent | React.KeyboardEvent) => {
        event.stopPropagation()
    }

    return (
        <div className={styles.base} onClick={stopRowClick} onKeyDown={stopRowClick} role="presentation">
            <Button
                variant={variant}
                size="sm"
                leftIcon={leftIcon}
                onClick={onClick}
                isProcessing={isProcessing}
                isDisabled={isDisabled}
            >
                {children}
            </Button>
        </div>
    )
}

export default ButtonCell
